// Home.vue

<template>
 
    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app dark :color="barColor">
      <img class="mr-3" :src="require('../../assets/Logo_SFR.svg')" height="40"/>
      <v-toolbar-title>
        <span class="hidden-xs-and-down">
          Caraïbe <span class="font-weight-thin text-sm-body-1">&copy; {{ annee}} <!-- v{{version}} --></span>
        </span>
      </v-toolbar-title>

      <v-spacer></v-spacer>

    </v-app-bar>

</template>
<script>

import {AppService} from '../../providers/AppService.js';
const appService = new AppService();
export default {  
  name: "BandeauToken",

  data: () => ({
    drawer: null,
    barColor: "black",
    sheet: false,
    version: null,
    annee: null,
  }),
  mounted: function () {
    this.version = appService.APP_VERSION;
    this.annee = (new Date()).getFullYear();
  }


};
</script>